import {organizationCodeValidator} from "../../js/validation/organizationCodeValidator";
import {withOrganizationCodeLookup} from "../../js/withOrganizationCodeLookup";
import {createBaseStore} from "../../components/custom-form-theme/CreateBaseFormStore";

export default function registerCustomerStore(formName, storeName, { sfFieldNameSuffix = '' }) {

    const store = withOrganizationCodeLookup(
        createBaseStore({ storeName, formName, sfFieldNameSuffix })
    );

   // store.values.cgu = false;
    // Validation defs
    store.definitions.organizationCode = { innerRules: true, customRules: [ organizationCodeValidator ] }
    store.definitions.plainPassword = {
        // Wrapper entre la fonction générique de vérif fourni par le DS et le comportement attendu
        // d'un validateur custom de la lib
        innerRules: true, customRules: {
            fn(domNode) {
                // TODO longueur en dur , devrait être injectée
                const res = window.DesignSystem.utils.validatePassword(domNode.value, 12)
                if (res.validPassword === true) {
                    return true;
                }
                return 'invalid';
            }
        }
    };
    // Init hook
    store._hooks.afterInit.push(function () {
        store.addChangeHandler('organizationCode', function (value) {
            store.handleOrganizationCodeChange(value, store.meta['organizationCode']);
        })
    });

    // Vérifie qu'on a bien un resolver pour le code orga
    if (store.setResolverOrganizationData === undefined) {
        console.error('ERROR : organizationCodeService : setResolverOrganizationData is undefined');
        console.log(JSON.stringify(store));

    }
    // Ajout et surcharges de fonction du store
    store.isRequired = function(fieldName) {
        return false;
    }

    // Validation impliquant plusieurs champs
    store.multiFieldValidators.push({
        fields: ['email', 'plainPassword', 'plainPasswordConfirm'],

        accept(fieldName) {
            return this.fields.includes(fieldName);
        },

        validate(store, triggeringField) {
            // Cas particulier de la confirmation de mot de passe ; si on valide l'un, on valide l'autre
            if (triggeringField === 'plainPassword') {
                store.validateField('plainPasswordConfirm', false)
            } else if (triggeringField === 'plainPasswordConfirm') {
                store.validateField('plainPassword', false)
            } else if (triggeringField === 'email') {
                // Spécifique au champs login qui suit l'email
                store.validateField('login', false)
            }

            if (store.values['plainPassword'] !== store.values['plainPasswordConfirm']) {
                store.addError('plainPasswordConfirm', 'passwordMisMatch');
            } else {
                store.removeError('plainPasswordConfirm', 'passwordMisMatch');
            }
        }
    });

    // Ajouter les mixins avant de mettre dans le store et d'init!
    Alpine.store(formName, store);
    window.registerCustomerStore = store;
    return store;
}

